import React from 'react';

import Icon from '@components/icon';
import Tooltip from '@components/tooltip';
import { classes } from 'as-ui-kit/utils/styles';

import { useLocalized } from 'utils/useLocalized';

import styles from '../styles.modules.scss';
import i18nStrings from './strings';
import AllFirmsSelectionCheckbox from '../../AllFirmsSelectionCheckbox';
import PropTypes from 'prop-types';
import Informer from 'components/Informer';

const TableHeader = ({showCount, locale, popoverFeature}) => {
    const strings = useLocalized(i18nStrings);
    return (
        <div className={styles['header']}>
	        <div className={styles['checkbox']}>
                <Informer
                    description={strings.canSelectAndInvite}
                    locale={locale}
                    popoverFeature={popoverFeature}
                >
		            <AllFirmsSelectionCheckbox showCount={showCount}/>
                </Informer>
	        </div>
            <div className={classes(styles['column'], styles['col_1'])}>
                {'#'}
            </div>
            <div className={classes(styles['column'], styles['col_2'])}>
                {strings.company}
            </div>
            <div className={classes(styles['column'], styles['col_3'], styles['with-question-col'])}>
	            <span className={styles['label']}>
                    {strings.actualTrucks}
	            </span>
                <Tooltip
                    content={strings.actualTrucksTooltip}
                    maxWidth={240}
                >
                    <Icon
	                    className={styles['header-tooltip']}
	                    color="#B8B8B8"
                        name="ic_information"
                        size="s"
                    />
                </Tooltip>
            </div>
            <div className={classes(styles['column'], styles['col_4'], styles['with-question-col'])}>
	            <span className={styles['label']}>
                    {strings.trucksCount}
	            </span>
                <Tooltip
                    content={strings.trucksCountTooltip}
                    maxWidth={240}
                >
                    <Icon
	                    className={styles['header-tooltip']}
	                    color="#B8B8B8"
                        name="ic_information"
                        size="s"
                    />
                </Tooltip>
            </div>
            <div className={classes(styles['column'], styles['col_5'], styles['with-question-col'])}>
	            <span className={styles['label']}>
                    {strings.searchCount}
	            </span>
                <Tooltip
                    content={strings.searchCountTooltip}
                    maxWidth={240}
                >
                    <Icon
	                    className={styles['header-tooltip']}
                        color="#B8B8B8"
                        name="ic_information"
                        size="s"
                    />
                </Tooltip>
            </div>
        </div>
    );
};

TableHeader.propTypes = {
    locale: PropTypes.string,
    popoverFeature: PropTypes.object,
    showCount: PropTypes.number.isRequired,
};

export default TableHeader;
